import { CaptureUserDetailsProps } from './types';

/**
 * Transforms a content-provided gate id key into a string that can be used
 * as an HTML id attribute.
 */
export const getSanitizedGateKey = (gateIdentifier: string): string => {
  let sanitizedId = gateIdentifier
    ?.trim()
    // replaces leading numbers with an empty string
    .replace(/^[0-9]+/, '')
    // replaces all non-alphanumeric characters with a hyphen
    .replace(/[^a-zA-Z0-9_-]/g, '-');

  if (sanitizedId?.startsWith('-')) {
    sanitizedId = sanitizedId.slice(1);
  }

  return 'GATE_ID-' + sanitizedId;
};

export const CLEARED = 'CLEARED';

export const getHasGateBeenCleared = (gateId: string) => {
  if (typeof localStorage === 'undefined') return true;

  const value = localStorage.getItem(gateId);

  if (value) return value === CLEARED;

  return false;
};

export const setGateCleared = (gateId: string) => {
  if (typeof localStorage === 'undefined') return;

  localStorage.setItem(getSanitizedGateKey(gateId), CLEARED);
  location.reload();
};

type GatedContentCMSBlock = {
  __component: 'shared.gated-content';
  gated_content_insert: {
    data: {
      attributes: CaptureUserDetailsProps;
    };
  };
};
export const isBlockGatedContentBlock = (
  block: any
): block is GatedContentCMSBlock => {
  return block?.__component === 'shared.gated-content';
};
